export const periodAvailabilityOptions = [
	{
		label: 'Available',
		value: true,
	},
	{
		label: 'Unavailable',
		value: false,
	},
];
